import { render } from "./EventosPage.vue?vue&type=template&id=47871a42&scoped=true"
import script from "./EventosPage.vue?vue&type=script&lang=js"
export * from "./EventosPage.vue?vue&type=script&lang=js"

import "./EventosPage.vue?vue&type=style&index=0&id=47871a42&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47871a42"]])

export default __exports__